import * as React from 'react';
import { BasePicker, IBasePickerProps, IPickerItemProps, Autofill, Icon } from "@fluentui/react"
// import { BasePicker, IBasePickerProps, IPickerItemProps } from 'office-ui-fabric-react/lib/Pickers';
// import { Autofill } from 'office-ui-fabric-react/lib/components/Autofill/Autofill';
// import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { IPickerTerm, IPickerTerms } from './ITermPicker';
import SPTermStorePickerService from '../../../services/SPTermStorePickerService';
import "./TaxonomyPicker.css";
import { ITaxonomyPickerProps } from './ITaxonomyPicker';
import { ITermSet } from "../../../interfaces/services/ISPTermStorePickerService";
import { LanguageContext } from "../../../../../utilities/LocalizationModule";

export class TermBasePicker extends BasePicker<IPickerTerm, IBasePickerProps<IPickerTerm>>
{

}

export interface ITermPickerState {
  terms: IPickerTerms;
  elRef?: React.LegacyRef<TermBasePicker> & React.LegacyRef<any>;
}

export interface ITermPickerProps {
  termPickerHostProps: ITaxonomyPickerProps;
  disabled: boolean;
  value: IPickerTerms;
  allowMultipleSelections: boolean;
  isTermSetSelectable?: boolean;
  disabledTermIds?: string[];
  disableChildrenOfDisabledParents?: boolean;
  placeholder?: string;

  onChanged: (items: IPickerTerm[]) => void;
  onInputChange: (input: string) => string;
  onBlur: (ev: React.FocusEvent<HTMLElement | Autofill>) => void;
}

export default class TermPicker extends React.Component<ITermPickerProps, ITermPickerState> {
  private allTerms: ITermSet = null;
  private termsService: SPTermStorePickerService;
  static contextType = LanguageContext

  constructor(props: any) {
    super(props);
    this.onRenderItem = this.onRenderItem.bind(this);
    this.onRenderSuggestionsItem = this.onRenderSuggestionsItem.bind(this);
    this.onFilterChanged = this.onFilterChanged.bind(this);
    this.onGetTextFromItem = this.onGetTextFromItem.bind(this);

    this.state = {
      terms: this.props.value
    };
    this.termsService = new SPTermStorePickerService(this.props.termPickerHostProps);
  }

  /**
   * componentWillReceiveProps method
   */
  public componentWillReceiveProps(nextProps: ITermPickerProps) {
    // check to see if props is different to avoid re-rendering
    let newKeys = nextProps.value.map(a => a.key);
    let currentKeys = this.state.terms.map(a => a.key);
    if (newKeys.sort().join(',') !== currentKeys.sort().join(',')) {
      this.setState({ terms: nextProps.value });
    }
  }

  /**
   * Renders the item in the picker
   */
  protected onRenderItem(term: IPickerItemProps<IPickerTerm>) {
    return (
      <div className={'pickedTermRoot'}
        key={term.index}
        data-selection-index={term.index}
        data-is-focusable={!term.disabled && true}>
        <span className={'pickedTermText'}>{term.item.name}</span>
        {
          !term.disabled && (
            <span className={'pickedTermCloseIcon'}
              onClick={term.onRemoveItem}>
              <Icon iconName="Cancel" />
            </span>
          )
        }
      </div>
    );
  }

  /**
   * Renders the suggestions in the picker
   */
  protected onRenderSuggestionsItem(term: IPickerTerm) {
    let termParent = term.termSetName;
    let termTitle = `${term.name} [${term.termSetName}]`;
    if (term.path.indexOf(";") !== -1) {
      let splitPath = term.path.split(";");
      termParent = splitPath[splitPath.length - 2];
      splitPath.pop();
      termTitle = `${term.name} [${term.termSetName}:${splitPath.join(':')}]`;
    }
    return (
      <div className={'termSuggestion'} title={termTitle}>
        <div>{term.name}</div>
        <div className={'termSuggestionSubTitle'}> {this.context.TaxonomyPickerInLabel} {termParent ? termParent : this.context.TaxonomyPickerTermSetLabel}</div>
      </div>
    );
  }

  private sortTerms(input: string, data: IPickerTerm[]): IPickerTerm[] {
    try {
      let first: IPickerTerm[] = [];
      let others: IPickerTerm[] = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].name.indexOf(input) == 0) {
          first.push(data[i]);
        } else {
          others.push(data[i]);
        }
      }
      first.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
      others.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
      return (first.concat(others));
    } catch (error) {
      console.warn(error);
    }
    return data;
  }

  /**
   * When Filter Changes a new search for suggestions
   */
  private async onFilterChanged(filterText: string, tagList: IPickerTerm[]): Promise<IPickerTerm[]> {
    if (filterText !== "") {
      const {
        termPickerHostProps,
        // context,
        isTermSetSelectable
      } = this.props;

      // let terms: IPickerTerm[] = await this.termsService.searchTermsByName(filterText);
      let terms: IPickerTerm[] = await this.termsService.findTerms([filterText]);
      // Check if the termset can be selected
      if (isTermSetSelectable && !termPickerHostProps.anchorId) {
        // Retrieve the current termset
        const termSet = await this.termsService.getTermSet();
        // Check if termset was retrieved and if it contains the filter value
        if (termSet && termSet.Name.toLowerCase().indexOf(filterText?.trim().toLowerCase()) === 0) {
          // Add the termset to the suggestion list
          terms.push({
            key: this.termsService.cleanGuid(termSet.Id),
            name: termSet.Name,
            path: "",
            termSet: this.termsService.cleanGuid(termSet.Id)
          });
        }
      }
      // Filter out the terms which are already set
      const filteredTerms: IPickerTerm[] = [];
      const { disabledTermIds, disableChildrenOfDisabledParents } = this.props;
      for (const term of terms) {
        let canBePicked = true;

        // Check if term is not disabled
        if (disabledTermIds && disabledTermIds.length > 0) {
          // Check if current term need to be disabled
          if (disabledTermIds.indexOf(term.key) !== -1) {
            canBePicked = false;
          } else {
            // Check if child terms need to be disabled
            if (disableChildrenOfDisabledParents) {
              // Check if terms were already retrieved
              if (!this.allTerms) {
                this.allTerms = await this.termsService.getAllTerms(this.props.termPickerHostProps.termsetNameOrID);
              }

              // Check if there are terms retrieved
              if (this.allTerms.Terms && this.allTerms.Terms.length > 0) {
                // Find the disabled parents
                const disabledParents = this.allTerms.Terms.filter(t => disabledTermIds.indexOf(t.Id) !== -1);
                // Check if disabled parents were found
                if (disabledParents && disabledParents.length > 0) {
                  // Check if the current term lives underneath a disabled parent
                  const findTerm = disabledParents.filter(pt => term.path.indexOf(pt.PathOfTerm) !== -1);
                  if (findTerm && findTerm.length > 0) {
                    canBePicked = false;
                  }
                }
              }
            }
          }
        }

        if (canBePicked) {
          // Only retrieve the terms which are not yet tagged
          if (tagList.filter(tag => tag.key === term.key).length === 0) {
            filteredTerms.push(term);
          }
        }
      }
      // return filteredTerms;
      return this.sortTerms(filterText, filteredTerms);
    } else {
      return Promise.resolve([]);
    }
  }

  /**
   * gets the text from an item
   */
  private onGetTextFromItem(item: any): any {
    return item.name;
  }

  /**
   * Render method
   */
  public render(): JSX.Element {
    const {
      disabled,
      value,
      onChanged,
      onInputChange,
      onBlur,
      allowMultipleSelections,
      placeholder
    } = this.props;

    const {
      terms
    } = this.state;

    return (
      <div>
        <TermBasePicker
          ref={(elRef: any) => {
            if (!this.state.elRef) {
              this.setState({ elRef });
            }
          }}
          disabled={disabled}
          onResolveSuggestions={this.onFilterChanged}
          onRenderSuggestionsItem={this.onRenderSuggestionsItem}
          getTextFromItem={this.onGetTextFromItem}
          onRenderItem={this.onRenderItem}
          defaultSelectedItems={value}
          selectedItems={terms}
          onChange={onChanged}
          onInputChange={onInputChange}
          onBlur={onBlur}
          itemLimit={!allowMultipleSelections ? 1 : undefined}
          className={'termBasePicker'}
          inputProps={{
            placeholder: placeholder
          }}
        />
      </div>
    );

  }
}
